import { select, put, call } from 'redux-saga/effects';

import showroom from '../../../libs/showroom'
import { Creators as actions } from '../../actions';
import {
    getPaymentOptions, getQuoteId, getConfig, getShowroomQueryParams
} from '../../selectors';
import updatePaymentOptions from './updatePaymentOptions';

/**
 * @param {Object} payload - Data from action
 */
function* updateProfitRoll(payload) {
    const quoteId = yield select(getQuoteId);
    const { showroomApiUrl, token } = yield select(getConfig);
    const queryParams = yield select(getShowroomQueryParams);

    const paymentOptions = yield select(getPaymentOptions);
    const {
        cashPurchaseOption,
        financeOptions,
        ...paymentOptionsData
    } = paymentOptions;

    const body = {
        calculationTargetType: payload.targetType,
        calculationTargetValue: parseFloat(payload.value),
        ...paymentOptionsData
    };

    try {
        const response = yield call(showroom.profitRoll, showroomApiUrl, token, quoteId, queryParams, body);
        yield call(updatePaymentOptions, {
            ...paymentOptions,
            ...response.negociationTransaction
        });
    } catch (error) {
        yield put(actions.handleError(error));
    }
}

export default updateProfitRoll;
